import { Type } from '@angular/core';
import { DynamicActionsBrickTypeEnum } from '../dynamic-actions-brick-configuration/dynamic-actions-brick-type-enum';
import { DynamicActionsBrickButtonsLayoutComponent } from './dynamic-actions-brick-buttons-layout/dynamic-actions-brick-buttons-layout.component';
import { DynamicActionsBrickDropdownLayoutComponent } from './dynamic-actions-brick-dropdown-layout/dynamic-actions-brick-dropdown-layout.component';
import { DynamicActionsBrickUnknownLayoutComponent } from './dynamic-actions-brick-unknown-layout/dynamic-actions-brick-unknown-layout.component';
import { IDynamicActionsBrickLayoutComponent } from './i-dynamic-actions-brick-layout-component';

/**
 * Helper class to resolve a circular dependency when defining the component directly in {@link DynamicActionsBrickLayoutTypeEnum}
 */
export class DynamicActionsBrickLayoutComponentResolver {
   static fromLayoutTypeEnum(layout: DynamicActionsBrickTypeEnum): Type<IDynamicActionsBrickLayoutComponent> {
      switch (layout.value) {
         case DynamicActionsBrickTypeEnum.BUTTONS.value:
            return DynamicActionsBrickButtonsLayoutComponent;
         case DynamicActionsBrickTypeEnum.DROPDOWN.value:
            return DynamicActionsBrickDropdownLayoutComponent;
         default:
            return DynamicActionsBrickUnknownLayoutComponent;
      }
   }
}
